import React, { Component } from 'react';
import style from '../share/pageList.module.css';
//import templateStyle from '../share/template.module.css';
import TemplateV2 from '../../components/TemplateV2';
import TextBoxWithLabel from '../../components/TextBoxWithLabel.js';
import DropDownWithLabel from '../../components/DropDownWithLabel.js';
import DatePickerWithLabel from '../../components/DatePickerWithLabel.js';

//import CheckBoxWithLabel from '../../components/CheckBoxWithLabel.js';
//import SearchBtn from '../../components/SearchBtn.js';
import DefaultBtn from '../../components/DefaultBtn.js';
import Paging from '../../components/Paging.js';

import * as utils from '../../components/Utils.js';
import BackDropLoading from '../../components/BackDropLoading.js';


import BookingDetail from './BookingDetail.js';


//import HotelCreate from './HotelCreate.js';
import axios from 'axios';
//import MenuLeft from '../../components/MenuLeft.js';

// import logoImage from '../assets/images/header_logo.svg';
// import MenuLeft from './MenuLeft.js';
//import artwork from '../assets/images/artwork.svg';

class EmailHistoryList extends Component {

    constructor(props) {
        //alert("emailhistorylist");
        super(props);
        this.state = {
            showCreate: false,
            showDelete: false,
            showDetail: false,
            selectId: null,
            selectMethod: "",
            loading: true,
            dataObject: null,
            searchObject: {
                // reservationCode: "",
                // dateType:"bookingdate",
                dateFrom: null,
                dateTo: null,
                // dateTypeList:[
                //     {value:"bookingdate",label:"Booking Date"},
                //     {value:"datein",label:"Date In"},
                //     {value:"dateout",label:"Date Out"},
                // ],
                send_status: "FAIL",
                statusList: [
                    { value: "ALL", label: "ALL" },
                    { value: "PENDING", label: "PENDING" },
                    { value: "SUCCESS", label: "SUCCESS" },
                    { value: "FAIL", label: "FAIL" },
                ]
            },
            Page: 1
        };
    }
    componentDidMount() {
        this.props.appState.checkUser(this.props.appState);

        if (this.props.site === "hopinn") {
            this.props.appState.checkRoles(this.props.appState, ["HopinnAdmin", "SystemAdmin"]);
        }
        this.callGetData();
    }
    callGetData() {
        //alert("test");
        let url = process.env.REACT_APP_API_END_POINT + "/api/BackOffice/MailHistoryList";
        //alert(url);
        let data = {};
        let appState = this.props.appState;

        data.searchObject = { ...this.state.searchObject };
        data.Page = this.state.Page;

        axios
            .post(url, data, {
                headers: {
                    'Authorization': appState.userObject.Token
                }
            })
            .then(response => {

                console.log(response.data);


                this.callGetDataCallBack(response.data.Data);
            })
            .catch(err => {
                console.error(err)
            })

        this.setState({
            loading: false
        })
    }
    callGetDataCallBack(data) {
        console.log(data);
        this.setState({
            dataObject: { ...data },
            loading: false
        })
    }

    handleChange = (e) => {
        //alert("change");
        let searchObject = { ...this.state.searchObject };
        //if (e.target.name === "reservationCode") searchObject.reservationCode = e.target.value;
        //if (e.target.name === "dateType")searchObject.dateType = e.target.value;
        //if (e.target.name === "dateFrom")searchObject.dateFrom = e.target.value;
        if (e.target.name === "send_status") searchObject.send_status = e.target.value;

        this.setState({
            searchObject: searchObject,
        })
    }
    pagingClick = (page) => {
        // let dataObject = { ...this.state.dataObject }
        // dataObject.page = page;
        // this.setState({
        //     dataObject: dataObject,
        // })
        this.state.Page = page;
        this.callGetData();
    }
    searchClick = () => {
        this.callGetData();
    }

    
    Resent(Id) {
        let url = process.env.REACT_APP_API_END_POINT + "/api/BackOffice/MailHistoryResend";
        let data = {};
        data.mailHistoryId = Id;
        let appState = this.props.appState;

        axios
            .post(url, data, {
                headers: {
                    'Authorization': appState.userObject.Token
                }
            })
            .then(response => {
                this.ResentCallBack(response.data);
            })
            .catch(err => {
                console.error(err)
            })

        this.setState({
            loading: true
        })
    }
    ResentCallBack(data) {
        console.log(data);

        if (data.Success === true) {
            //alert("success");
            this.setState({
                loading: false,
            })
            this.callGetData();
            //this.props.onClose();
        }
        else {
            this.setState({
                loading: false,
            })
            this.callGetData();
        }
    }






    showDelete(Id) {
        this.setState({
            showCreate: true,
            selectId: Id,
            selectMethod: "Delete"
        })
    }
    showEdit(Id) {
        //alert(Id);
        this.setState({
            showDetail: true,
            selectId: Id,
            //selectMethod: "Edit"
        })
    }

  


    back = () => {
        this.setState({
            showDetail: false,
            selectId: null,
            //selectMethod: "Edit"
        })
    }



    showCreate = () => {
        this.setState({
            showCreate: true,
            selectId: null,
            selectMethod: "Create"
        })
    }
    hideCreate = () => {
        //alert("test");
        this.setState({
            showCreate: false,
            showDelete: false,
            selectId: null,
            selectMethod: "Create"
        })
        this.callGetData();
    }
    renderTable() {










        let tableRow = [];
        let dataObject = this.state.dataObject;

        if (dataObject !== null) {
            let dataList = dataObject.dataList;

            for (let i = 0; i < dataList.length; i++) {
                let node = dataList[i];
                let active = node.IsEnable === true ? "Enable" : "Disable";
                let guest = node.givenName + " " + node.surName;
                let balance = utils.numberWithCommas(node.balance, 2);
                let status = "booked";



                let UpdateAt = utils.stringToDateWithTime(node.UpdateAt);




                // if(node.status === 9){
                //     status = "cancel";
                // }

                tableRow.push(
                    <tr key={node.Id}>
                        
                        <td onClick={(e) => this.Resent(node.Id)} className={style.columnPointer}><div className={style.small_btn}>ReSent</div></td>
                        {node.send_status === "PENDING" && <td><div className={style.pendingbadge}>{node.send_status}</div></td>}
                        {node.send_status === "SUCCESS" && <td><div className={style.successbadge}>{node.send_status}</div></td>}
                        {node.send_status === "FAIL" && <td><div className={style.failbadge}>{node.send_status}</div></td>}
                        
                        <td>{node.tos}</td>
                        <td>{node.bccs}</td>
                        <td>{node.subject}</td>
                        <td>{node.errors}</td>                        
                        <td>{UpdateAt}</td>
                    </tr>
                );
            }
        }
        return (
            <div className={style.tableArea}>
                <table>
                    <thead>
                        <tr>
                            <th></th>
                            <th>Status</th>
                            <th>TO</th>
                            <th>BCC</th>
                            <th>Subject</th>
                            <th>Error</th>
                            <th>Update</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tableRow}
                    </tbody>
                </table>
                {dataObject !== null &&
                    <Paging dataObject={dataObject} onClick={this.pagingClick} />
                }
            </div>
        );
    }
    render() {
        let table = this.renderTable();
        return (
            <TemplateV2 appState={this.props.appState} page={"emailhistorylist"}>
                <div className={style.page}>
                    <BackDropLoading show={this.state.loading} key="hotel" />

                    {/* {(this.state.showSuccess === true) &&
                        <div className={style.message_bar}>
                            Your data was save.
                        </div>
                    } */}

                    <div className={style.navBar}>
                        <div className={style.nav}>Home</div>
                        <i className="fas fa-chevron-right"></i>
                        <div className={style.navSelect}>Sentbox List</div>
                        {/* <i className="fas fa-chevron-right"></i>
                    <div className={style.navSelect}>Create</div> */}
                    </div>

                    {this.state.showCreate !== true && this.state.loading !== true && this.state.showDelete !== true &&

                        <>
                            <div className={style.searchArea}>
                                <div className={style.searchBox}>
                                    {/* <div className={style.searchBoxInput}>
                                        <TextBoxWithLabel onChange={this.handleChange} value={this.state.searchObject.Name} name="Name" label="Name" />
                                    </div> */}



                                    <div className={style.row}>
                                        <div className={style.searchBoxInput}>
                                            <DropDownWithLabel onChange={this.handleChange} options={this.state.searchObject.statusList} value={this.state.searchObject.send_status} name="send_status" label="Status" />
                                        </div>
                                        <div className={style.searchBoxInput}>
                                            <DatePickerWithLabel onChange={this.handleChange} value={this.state.searchObject.dateFrom} name="dateFrom" label="Date From" />
                                        </div>


                                        <div className={style.searchBoxInput}>
                                            <DatePickerWithLabel onChange={this.handleChange} value={this.state.searchObject.dateTo} name="dateTo" label="Date To" />
                                        </div>
                                        <div className={style.searchBoxBtn}>
                                            <DefaultBtn label="Search" type="primary" onClick={this.searchClick} />
                                        </div>
                                    </div>





                                </div>
                            </div>

                            <div className={style.contentArea}>
                                <div className={style.contentBox}>
                                    <div className={style.contentTitle}>Sentbox List</div>

                                    <div className={style.line}></div>

                                    {/* <div className={style.toolArea}>
                                        <div className={style.toolBtn} onClick={this.showCreate}>
                                            <i className="fas fa-plus"></i>
                                            Create
                                        </div>
                                    </div> */}
                                    <div className={style.line}></div>
                                    {table}
                                </div>
                            </div>
                        </>
                    }
                    {/* {this.state.showCreate === true &&
                        <HotelCreate Id={this.state.selectId} onClose={this.hideCreate} method={this.state.selectMethod} appState={this.props.appState} />
                    } */}
                </div>
            </TemplateV2>




            // </div>


            // </div>

        );
    }
}
export default EmailHistoryList